import { render, staticRenderFns } from "./BarRaceChartAnswer.vue?vue&type=template&id=5510e208&"
import script from "./BarRaceChartAnswer.vue?vue&type=script&lang=js&"
export * from "./BarRaceChartAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports